<div class="top">
    <div class="dynamic">
        <div class="row">
            <div class="column1">
                <div class="innerbox">

                    <form class="example-form" [formGroup]="form" (ngSubmit)="submit()" *ngIf="!display">
                        <h2 align="center" style="margin-top: 10px;margin-bottom: 20px;">Login</h2>

                        <h4 align="center">Forgot Your Password?</h4>
                        <p align="center">Don't worry! Resetting your password is easy.Just type in the email you
                            regeisterd to <b>yourDesiCart</b></p>
                        <mat-form-field class="example-full-width border-white">
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Enter your email address" formControlName="email" id="email"
                                [(ngModel)]="email" type="text" required maxlength="40"/>
                            <mat-error *ngIf="f.email.errors?.email && !f.email.errors?.required">
                                Please enter a valid email address
                            </mat-error>
                            <mat-error *ngIf="f.email.errors?.required">
                                Email is <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                        <br><br>
                        <!-- <p style="color: red;" align="center">{{Message}}</p> -->
                        <div class="center">
                            <button mat-raised-button color="dark" class="btn button-style float-none"
                                type="submit">SEND</button>
                            <!-- [disabled]="!form.valid" -->
                        </div>
                        <div>
                            <p style="margin: 15px;text-align: center;">Did you remembered your password?<a
                                    [routerLink]="[]" (click)="signup()"> Try loging in</a>
                            </p>
                        </div>
                    </form>
                    <form class="example-form" [formGroup]="form" (ngSubmit)="reset()" *ngIf="display">
                        <h2 align="center" style="margin-top: 10px;margin-bottom: 20px;">Login</h2>

                        <h4 align="center">Reset Your Password?</h4>
                        <p align="center">Don't worry! Resetting your password is easy.Just type in the new Password you
                            regeisterd to <b>yourDesiCart</b></p>
                        <mat-form-field class="example-full-width border-white">
                            <mat-label>Enter New Password</mat-label>
                            <input matInput placeholder="Password" formControlName="password" [(ngModel)]="password"
                                [type]="hide ? 'password' : 'text'" required maxlength="40"/>
                            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                            <mat-error *ngIf="!f.password.errors?.required && f.password.errors?.maxlength">
                                Please, Enter 8 character Password.
                            </mat-error>
                            <mat-error *ngIf="f.password.errors?.required">
                                Password is <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                        <br><br>
                        <!-- <p style="color: red;" align="center">{{Message}}</p> -->
                        <div class="center">
                            <button mat-raised-button color="dark" class="btn button-style float-none"
                                type="submit">SEND</button>
                            <!-- [disabled]="!form.valid" -->
                        </div>
                        <div>
                            <p style="margin: 15px;text-align: center;">Did you remembered your password?<a
                                    [routerLink]="[]" (click)="signup()"> Try loging in</a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>